import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import useStyles from './divider.styles';

const Divider = ({ label, className }) => {
  const classes = useStyles();

  if (label) {
    return (
      <div className={clsx(classes.divider, className)}>
        <span className={classes.label}>{label}</span>
      </div>
    );
  }

  return <div className={clsx(classes.divider, className)} />;
};

Divider.propTypes = {
  label: PropTypes.string
};

export default Divider;
